
        require('./index.scss');
        'use strict';

var $ = window.$;
var $modAll = $('.module-baidu-union');

var _module = {
    init: function init($mod) {
        setTimeout(function () {
            if ($mod.find('iframe').length > 0) {
                if (!!$mod.attr('data-shadow')) {
                    $mod.addClass('shadow');
                } else {
                    $mod.addClass('has-be');
                }

                if (!!$mod.attr('data-marginTop')) {
                    $mod.css({ 'margin-top': $mod.attr('data-marginTop') });
                }
            }
        }, 1000);

        if ($('body').attr('data-page-name') === 'news-detail') {
            var handler = setInterval(function () {
                var moduleSh = $('.module-hot-second-hand');
                if (moduleSh && moduleSh.length > 0 && moduleSh.height() > 0) {
                    clearInterval(handler);
                } else {
                    $('.module-baidu-union[data-maybehide="true"]').remove();
                }
            }, 1000);
            setTimeout(function () {
                clearInterval(handler);
            }, 4000);
        }
    }
};

$modAll.each(function (i, v) {
    _module.init($(v));
});;
    


// WEBPACK FOOTER //
// ./src/module/common/baidu-union/index.js